import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

@Component({
  selector: 'app-scroll-loader',
  templateUrl: './scroll-loader.component.html',
  styleUrls: ['./scroll-loader.component.scss'],
})
export class ScrollLoaderComponent implements OnDestroy, AfterViewInit {
  @Output() scrolled = new EventEmitter<void>();
  @Input() scrollContainer?: HTMLElement;
  @Input() onlyAtBottom = false;
  loading = false;

  private observer: IntersectionObserver | null = null;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.setupObserver();
  }

  ngOnDestroy() {
    this.disconnectObserver();
  }

  setLoading(loading: boolean): void {
    this.loading = loading;
  }

  /**
   *
   * Checks if the container has enough content to scroll
   *
   * @returns boolean indicating if the container can scroll
   */
  private hasScrollableContent(): boolean {
    const container = this.scrollContainer || document.documentElement;
    // If scrollHeight is greater than clientHeight, there's scrollable content
    return container.scrollHeight > container.clientHeight;
  }

  private setupObserver(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loading) {
            // First check if there's enough content to scroll
            if (!this.hasScrollableContent()) {
              return;
            }

            if (this.onlyAtBottom) {
              // Check if we're at the bottom of the container
              const container = this.scrollContainer || document.documentElement;
              const atBottom = Math.abs(container.scrollHeight - container.scrollTop - container.clientHeight) < 10;
              if (atBottom) {
                this.loading = true;
                this.scrolled.emit();
              }
            } else {
              this.loading = true;
              this.scrolled.emit();
            }
          }
        });
      },
      {
        root: this.scrollContainer || null,
        rootMargin: '0px 0px 20px 0px', // Reduced margin to be closer to the bottom
        threshold: 0.1,
      }
    );

    this.observer.observe(this.el.nativeElement);
  }

  private disconnectObserver(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
